export enum ServerSortedField {
  EFFECTIVE_DATE = 'effectiveDate',
}
